import { render, staticRenderFns } from "./no-access.vue?vue&type=template&id=010928ae&scoped=true&"
import script from "./no-access.vue?vue&type=script&lang=js&"
export * from "./no-access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010928ae",
  null
  
)

export default component.exports